import React from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import "./c93_home_contact.scss"
import InnerHTML from 'dangerously-set-html-content';

class C93HomeContact extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            btnHidden: '',
            dataIndex: null,
            disabled: false,
            slideIndex: 1,
            updateCount: 0
        };

        this.requireInternationalization = true;

        //this.dataUrl = this.dataUrl.replace('https://ho4out7of9.execute-api.eu-west-1.amazonaws.com/prod', 'https://www.luiss.it')
    };


    internationalComponentRender(data, t) {
        function homeContractCard(singleContent, index) {
            return (
                <div className="card-wrapper" key={index}>
                    <InnerHTML html={singleContent} />
                </div>
            )
        }
        const title = (
            <div className="title-wrapper">
                <h1>{data.title}</h1>
                <p>{data.description}</p>
                <button><a href={data.link_url}>{data.link_title}</a></button>
            </div>
        )
        return (
            <div className="home-contract">
                {title}
                <div className="card-wrapper">
                    <InnerHTML html={data.content_left} />
                </div>
                <div className="card-wrapper">
                    <InnerHTML html={data.content_right} />
                </div>
            </div>)
    }
}

export default C93HomeContact;